import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';

const PESOSDCSWIFT: string[] = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('').map(letra => letra);

const calcularDC = (cadena: string): string => {
  const tablaPesos = [6, 3, 7, 9, 10, 5, 8, 4, 2, 1];
  let suma = 0;
  let dcParcial: number;
  for (let i = 0; i < cadena.length; i++) {
    suma = suma + Number(cadena.charAt(cadena.length - 1 - i)) * tablaPesos[i]
  }
  dcParcial = (11 - (suma % 11));
  if (dcParcial === 11) {
    dcParcial = 0
  } else if (dcParcial === 10) {
    dcParcial = 1
  }
  return dcParcial.toString()
}

const ISO7064MOD97_10 = (iban: string): number => {
  let remainder: string = iban, block: string;
  while (remainder.length > 2) {
    block = remainder.slice(0, 9);
    remainder = parseInt(block, 10) % 97 + remainder.slice(block.length);
  }
  return parseInt(remainder, 10) % 97
}

const calcularPesoLetraCIF = (letra: string): number => PESOSDCSWIFT.indexOf(letra) >= 0
  ? 10 + PESOSDCSWIFT.indexOf(letra)
  : null;

export const checkNIF = (nif: string): boolean => {
  if (!nif) return false;
  const validChars = 'TRWAGMYFPDXBNJZSQVHLCKET';
  const dni: string = nif.toString().toUpperCase();
  const nie: string = dni
    .replace(/^[X]/, '0')
    .replace(/^[Y]/, '1')
    .replace(/^[Z]/, '2');
  const letter: string = dni.slice(-1);
  const charIndex: number = parseInt(nie.slice(0, 8), 0) % 23;
  return validChars.charAt(charIndex) === letter
}

export const validateIdentity = (value: string): boolean => {
  if (!value) return false;
  const id = value.toString().toUpperCase().trim();
  const regexCIF = /^([A-W]{1}[0-9]{8})/;
  if (regexCIF.test(id)) return true;
  return checkNIF(id)
}

export const dniValidator = (): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    const val = control.value;
    if (!val) return null;
    const dniMayus = val.toUpperCase();
    if (dniMayus.length > 9) return {maxChar: true};
    if (!checkNIF(dniMayus)) return {letra: true};
    return null
  }
}

export const calcularIBAN = (IBAN: string[]): string => {
  const dc1 = IBAN[4].slice(0, 1);
  const dc2 = IBAN[4].slice(1, 2);
  const resto = IBAN[4].slice(2);
  if (calcularDC(IBAN[2] + IBAN[3]) === dc1 && calcularDC(resto + IBAN[5] + IBAN[6]) === dc2) {
    const ibanPrevio = IBAN[2] + IBAN[3] + IBAN[4] + IBAN[5] + IBAN[6] + '142800';
    let digitoControl: string | number = 98 - ISO7064MOD97_10(ibanPrevio);
    return `ES${String(digitoControl).padStart(2, '0')}`
  }
  return null
}

export const checkIBAN = (iban: string): boolean => {
  if (iban?.length !== 24) return false;
  const IBAN = [null, iban.slice(0, 4), iban.slice(4, 8), iban.slice(8, 12),
    iban.slice(12, 16), iban.slice(16, 20), iban.slice(20)];
  return IBAN[1].localeCompare(calcularIBAN(IBAN)) === 0
}

export const calcularIdentificadorSEPA = (cif: string, sufijo: string): string => {
  const ident = cif.toString().toUpperCase();
  const resto: string = ident.slice(1, 8);
  let primera: number | string = ident.slice(0, 1);
  let ultima: number | string = ident.slice(8);
  let value: string = '';
  if (calcularPesoLetraCIF(primera)) {
    primera = calcularPesoLetraCIF(primera);
  }
  if (!primera) return '';
  value += primera + resto;
  if (calcularPesoLetraCIF(ultima)) {
    ultima = calcularPesoLetraCIF(ultima);
  }
  if (!ultima) return '';
  value += `${ultima}142800`;
  let digitoControl: string | number = 98 - ISO7064MOD97_10(value);
  return `ES${String(digitoControl).padStart(2, '0')}${sufijo}${ident}`
}

